import React from 'react';
import { Element, Color } from '@americanexpress/aqx-components';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';

const FeatureBullet = ({
  imageUrl,
  imageAlt,
  header,
  description,
  styles,
  logo,
  logoAlt,
  descriptionList,
  button
}) => {
  return (
    <div className={styles.bullet}>
      {header && (
        <Element
          Component="p"
          className={styles.bulletHeader}
          theme={{
            textBody: 3,
            color: Color.Gray06,
            padding: 'none',
            margin: 'none',
            paddingTop: 10,
            paddingBottom: 10
          }}
        >
          {header}
        </Element>
      )}
      {description && (
        <Element
          Component="p"
          className={styles.bulletDescription}
          theme={{
            textBody: 3,
            color: Color.Gray06,
            margin: 'none',
            padding: 'none',
            paddingTop: 10,
            paddingRight: 20,
            paddingBottom: 10
          }}
        >
          <Sanitizer safelySetInnerHTML={description} />
          {button && (
            <Element Component="a" href={button.url} target="_blank">
              <Sanitizer safelySetInnerHTML={button.title} />
            </Element>
          )}
        </Element>
      )}
      {descriptionList && (
        <Element Component="ul" className={styles.listContainer}>
          {descriptionList.map(item => (
            <Element Component="li" className={styles.listItem} key={item}>
              <Sanitizer safelySetInnerHTML={item} />
            </Element>
          ))}
        </Element>
      )}
      {(imageUrl || logo) && (
        <div className={styles.logoContainer}>
          {imageUrl && <img src={imageUrl} alt={imageAlt} className={styles.logo} />}
          {logo && <img src={logo} className={styles.logo} alt={logoAlt} />}
        </div>
      )}
    </div>
  );
};

export default FeatureBullet;
